import React, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import * as styled from './styled/TextInput.styled';

export const TextInput: React.FC<{
    disabled?: boolean;
    name: string;
    width?: number;
}> = ({ disabled = false, name, width }) => {
    const { register, setValue, watch } = useFormContext();
    const watchValue = watch(name);
    useEffect(() => {
        setValue(name, watchValue);
    }, []);
    const methods = register(name);

    return (
        <>
            <styled.TextInput
                $width={width}
                disabled={disabled}
                id={name}
                {...methods}
                value={watchValue || ''}
            />
        </>
    );
};
